export default "__VITE_ASSET__BBe355ne__"